import makeStyles from '@material-ui/core/styles/makeStyles'

export const useStyles = makeStyles((theme) => ({
  filterSelectorContainer: {
    padding: `${theme.spacing(0)}px ${theme.spacing(2)}px`,
  },
  filterGroupContainer: {
    paddingTop: theme.spacing(3),
  },
  inactiveSelectItem: {
    color: theme.palette.text.secondary,
  },
  selectOptionDisabled: {
    cursor: 'auto',
  },
  filterSelectIcon: {
    color: theme.palette.text.primary,
  },
}))
